import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';

import { RadioControlled } from 'components/_basic/Form/Radio';
import { CurrencyUnitSelector } from 'components/BusinessToolForm/components/CurrencyUnitSelector/CurrencyUnitSelector';
import { useGetPeriodOptions } from 'components/BusinessToolForm/constants/periods';
import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { IProfitAndLossProjectionFormHeaderProps } from './types';
import { prefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES } from '../../utils/form';

import styles from './ProfitAndLossProjectionFormHeader.module.scss';

export const ProfitAndLossProjectionFormHeader: React.FC<IProfitAndLossProjectionFormHeaderProps> = ({ disabled }) => {
  const { control } = useFormContext();
  const periodOptions = useGetPeriodOptions();

  return (
    <Box className={styles.header}>
      <RadioControlled
        id="profitAndLossProjectionFormHeader.period"
        name={GLOBAL_PERIOD_NAME}
        control={control}
        options={periodOptions}
        disabled={disabled}
      />

      <CurrencyUnitSelector
        name={concatWithDot(prefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.CURRENCY)}
        disabled={disabled}
      />
    </Box>
  );
};
